import { m } from 'motion/react';
import avif96 from '@/assets/brand/logo-disc-96.avif';
import webp96 from '@/assets/brand/logo-disc-96.webp';
import avif192 from '@/assets/brand/logo-disc-192.avif';
import webp192 from '@/assets/brand/logo-disc-192.webp';
import avif384 from '@/assets/brand/logo-disc-384.avif';
import webp384 from '@/assets/brand/logo-disc-384.webp';
import { cx } from '@/lib/cx';

/** The round logo. `layoutId` lets the login disc fly into the sidebar slot. */
export function LogoDisc({ size = 40, className, layoutId }: { size?: number; className?: string; layoutId?: string }) {
  return (
    <m.picture layoutId={layoutId} className={cx('block shrink-0 rounded-full', className)} style={{ width: size, height: size }}>
      <source type="image/avif" srcSet={`${avif96} 96w, ${avif192} 192w, ${avif384} 384w`} sizes={`${size}px`} />
      <source type="image/webp" srcSet={`${webp96} 96w, ${webp192} 192w, ${webp384} 384w`} sizes={`${size}px`} />
      <img
        src={webp192}
        width={size}
        height={size}
        alt="Marmolería DEC"
        className="size-full rounded-full shadow-[0_2px_10px_-2px_rgb(28_26_23/0.45),0_0_0_1px_rgb(184_134_47/0.35)]"
        draggable={false}
      />
    </m.picture>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <div className={cx('leading-none', className)}>
      <div className="text-[10px] font-semibold tracking-[0.32em] text-ink-500">MARMOLERÍA</div>
      <div className="font-display gold-text text-[22px] tracking-[0.18em]">DEC</div>
    </div>
  );
}
